import { IMPERSONATION_TOKEN_KEY } from "./constants";

export const persistImpersonation = (jwt: string, ownerSub?: string) => {
  localStorage.setItem(IMPERSONATION_TOKEN_KEY, JSON.stringify({ jwt, ownerSub }));
};
